import { ProfileAvatarConnected } from "PFApp/components/profile_avatar_connected";
import { RoleProfileActionButtonsWrapper } from "PFApp/components/role_profile_action_buttons";
import { ActionIcon } from "PFComponents/action_icon";
import { Avatar } from "PFComponents/avatar";
import { MatchAccuracyBadge } from "PFComponents/resource_metrics/match_accuracy";
import { profileHash } from "PFCore/helpers/profile_hash";
import { ProfileNameLink } from "PFCore/helpers/profile_name_link";
import { useHasOpenVacancy } from "PFCore/hooks/queries/activity";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { Activity } from "PFTypes";

import { useActivityTemplateType } from "../../hooks";
import cssDetails from "./compare_details_page.module.scss";
import css from "./compare_profile_header.module.scss";
import { GradeAndRateCell } from "./parts/grade_and_rate_cell";
import { ComparableProfile } from "./parts/use_cell_data";

type CompareProfileHeaderProps = {
  activity: Activity;
  comparableProfile: ComparableProfile;
  removeProfileId: (id: number) => void;
  isUnbiased?: boolean;
};

export const CompareProfileHeader = ({
  activity,
  comparableProfile,
  removeProfileId,
  isUnbiased
}: CompareProfileHeaderProps) => {
  const { isAudit } = useActivityTemplateType(activity);
  const { data: hasOpenVacancy, isFetching } = useHasOpenVacancy({ activityId: activity.id });
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  const { profile } = comparableProfile;
  const normalizedScore = comparableProfile.scores?.normalizedScore;
  const isShortlisted = !!comparableProfile.state;
  const isFillDisabled = isFetching || !hasOpenVacancy;

  return (
    <th className={cssDetails.th}>
      <div className={css.profileHeader}>
        {isUnbiased ? (
          <Avatar size={30} backgroundColor="#ffc0cb" text={profileHash(profile.id)} />
        ) : (
          <ProfileAvatarConnected profile={profile} size={30} />
        )}

        {isUnbiased ? (
          <div className={css.unbiasedCandidate}>{getUnbiasedProfileName(profile, isUnbiased)}</div>
        ) : (
          <div className={css.name}>
            &nbsp; {/* handle flex empty cell */}
            <span className={css.nameInner}>
              <ProfileNameLink profile={profile} className={css.profileLink} />
            </span>
          </div>
        )}

        {normalizedScore && (
          <div className={css.rating}>
            <MatchAccuracyBadge value={normalizedScore} />
          </div>
        )}

        <ActionIcon name="cross" size="xxs" onClick={() => removeProfileId(profile.id)} />
      </div>
      {!isAudit && (
        <RoleProfileActionButtonsWrapper
          role={activity}
          profile={profile}
          shortlist={isShortlisted ? { id: comparableProfile.id, state: comparableProfile.state } : null}
          isFillDisabled={isFillDisabled}
          className={css.buttons}
          isShortlistTabActive
          isCompareView
        />
      )}
      <GradeAndRateCell profile={profile} />
    </th>
  );
};
